import superagent from 'superagent';

export default async function buttonFormROP() {
  const webserviceCarrito = process.env.REACT_APP_CARRITO_WEBSERVICE;

  let response = '';

  await superagent
    .get(`${webserviceCarrito}/USA/ROP/ROP?pais=US`)
    .set('Content-Type', 'application/json')
    .then((res) => {
      const { body = {} } = res;

      console.log(body, 'response nody');
      if (body.codigoMensaje === 200) {
        response = body.data.idROP;
      } else {
        console.log(body.message);
        response = '';
      }
    })
    .catch((err) => {
      console.log(err);
    });

  return response;
}
